import {
  Button,
  Classes,
  ControlGroup,
  Dialog,
  FormGroup,
  Tag,
} from '@blueprintjs/core';
import { Users } from '@just-in-types';
import * as React from 'react';
import styled from 'react-emotion';
import { CheckIns, CheckInsColumnOptions } from '.';
import "../../styles/viewoptionpg.css";
import ViewOptionsPicker from './ViewOptionsPicker';

interface Props {
  fontSize: number;
  modeArr:ModeArr,
  onSetFontSize: CheckIns['setFontSize'];
  onUpdateColumnOptions: (
    columnOptions: Users.ColumnOptions[],
    path: CheckInsColumnOptions,
  ) => Promise<void>;
  previewOptions: Users.ColumnOptions[];
  tableOptions: Users.ColumnOptions[];
}

interface ModeArr{
  background? : string;
  fontColor? : string;
  mode: string;
  tableBgColor?:string;
  tableBorder?:string;
  tableFontColor?:string;
}

interface State {
  isOpen: boolean;
}
{/* <style>
.bp3-button.bp3-minimal.bp3-intent-primary {
   { color: '#FFF'}
}  
</style> */}
const ColumnsWrapper = styled('div')`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 0.5rem;
`;

class CheckInsOptions extends React.PureComponent<Props, State> {
  public constructor(props: Props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  public render() {
    const {
      fontSize,
      tableOptions,
      onUpdateColumnOptions,
      previewOptions,
    } = this.props;
    const { isOpen } = this.state;

    return (
      <>
        <Button icon="cog" minimal={true} onClick={this.toggleOpen} />
        <Dialog isOpen={isOpen} onClose={this.close} title="View Options">
          <div className={Classes.DIALOG_BODY} id="view-opt-style">
            <FormGroup label="Font Size">
              <ControlGroup>
                <Tag minimal={true}>{`${fontSize}px`}</Tag>
                <Button icon="minus" onClick={this.decreaseFontSize} />
                <Button icon="add" onClick={this.increaseFontSize} />
              </ControlGroup>
            </FormGroup>
            <ColumnsWrapper>
              <ViewOptionsPicker
                columnOptions={previewOptions}
                modeArr={this.props.modeArr}
                onUpdateColumnOptions={onUpdateColumnOptions}
                path="previewOptions"
                title="Preview Fields"
              />
              <ViewOptionsPicker
                columnOptions={tableOptions}
                modeArr={this.props.modeArr}
                onUpdateColumnOptions={onUpdateColumnOptions}
                path="tableOptions"
                title="Table Columns"
              />
            </ColumnsWrapper>
          </div>
        </Dialog>
      </>
    );
  }

  private close = () => this.setState({ isOpen: false });

  private toggleOpen = () =>
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));

  private increaseFontSize = () =>
    this.props.onSetFontSize(fontSize => fontSize + 2);

  private decreaseFontSize = () =>
    this.props.onSetFontSize(fontSize => fontSize - 2);
}

export default CheckInsOptions;



// WEBPACK FOOTER //
// ./src/views/CheckIns/ViewOptions.tsx